import React from 'react';
import _ from 'lodash';
import { Button, ButtonGroup, Form, Label, Input } from 'reactstrap';
import ButtonAction from './ButtonAction';
import SettingsModal from './SettingsModal';
import { conversionOutput, getFileTypeName } from '../helpers/FileHelpers';

export default class ConversionForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen });
  }

  openModal = (e) => {
    e.preventDefault();
    this.toggleModal();
  }

  handleInputChange = (e) => {
    this.setState({ input: e.target.value });
  }

  handleOutputChange = (e) => {
    this.setState({ conversion: e.target.value });
  }

  sortableFileName(slug) {
    return getFileTypeName(slug).toLowerCase();
  }

  availableInputs = () => _.chain(this.props.conversions.map(conv =>
      conv.input,
    )).uniq().sortBy(c => this.sortableFileName(c)).value()

  conversionsForInput = () => _.chain(this.props.conversions.filter(conv =>
      conv.input === this.state.input,
    )).sortBy(c => this.sortableFileName(c.output)).value()

  output() {
    const o = _.find(this.props.conversions, c => c.slug === this.state.conversion);
    return o.output;
  }

  settings() {
    return this.props.settings[this.state.conversion];
  }

  performConversion = (e) => {
    e.preventDefault();
    this.props.performConversion(this.state.conversion);
  }

  componentDidMount = () => {
    const currentInputs = this.availableInputs();
    if (currentInputs.length === 1) {
      this.setState({ input: currentInputs[0] });
    } else if (this.props.target) {
      this.setState({ input: this.props.target });
    }
  }

  render() {
    const currentInputs = this.availableInputs();
    return (<Form className="conversion-form">
      <div>
        <Input
          name="conversion-input"
          onChange={this.handleInputChange}
          type="select"
          className="convert-dropdown"
          defaultValue={this.props.target ? this.props.target : 'def-input'}
        >
          {currentInputs.length > 1 ?
            <option value="def-input">Select input type</option>
            : null}
          {this.availableInputs().map((input, index) => (<option key={`optinp${index}`} value={input}>
            {getFileTypeName(input)}
          </option>))}
        </Input>
      </div>
      <span className="converter-arrow">
        <i className="fa fa-cogs" />
        <i className="fa fa-long-arrow-right" />
      </span>
      <div>
        <Input
          name="conversion-output"
          onChange={this.handleOutputChange}
          type="select"
          className="convert-dropdown"
          disabled={!this.state.input}
          defaultValue="def-output"
        >
          <option value="def-output">Select output type</option>
          {this.conversionsForInput().map((conv, index) => (<option key={`optout${index}`} value={conv.slug}>
            {conversionOutput(this.state.input, conv.output)}
          </option>))}
        </Input>
      </div>
      <div className="convert-btn-group">
        <ButtonAction
          icon="fa-cog"
          color="secondary"
          title="Settings"
          disabled={!this.state.conversion}
          action={this.openModal}
        >
          <span className="hidden-md-down">
              Edit Settings
            </span>
        </ButtonAction>
        {this.state.conversion ?
          <SettingsModal
            key={Math.random()}
            ref="settingsModal"
            modalOpen={this.state.modalOpen}
            closeModal={this.toggleModal}
            input={this.state.input}
            output={this.output()}
            updateSettings={this.props.updateSettings}
            settings={this.settings()}
          /> : null}
        <Button
          onClick={this.performConversion}
          disabled={!this.state.conversion}
          title="Perform conversion"
          className="convert-button"
          color="success"
          type="submit"
        >
            Convert
          </Button>
      </div>
    </Form>);
  }
}
